// action types
import ApiService from "../api.service";
import {SET_ERROR} from "./auth.module";
import {EXPORT_EXCEL} from "./profile.module";

export const REPORT_HUMANRE_SOURCE = "report/human-resource";
export const REPORT_KINH_DOANH_DOI = "payment/bao-cao-doi";
export const REPORT_KINH_DOANH_DOI_V2 = "payment/bao-cao-doi-v2";
export const REPORT_KINH_DOANH_DOI_CHI_TIET = "payment/bao-cao-doi-chi-tiet";
export const REPORT_KINH_DOANH_DOI_CHI_TIET_V2 = "payment/bao-cao-doi-chi-tiet-v2";
export const REPORT_KINH_DOANH_NGAY = "payment/bao-cao-ngay";
export const REPORT_KINH_DOANH_KENH = "payment/bao-cao-kenh";
export const REPORT_KINH_DOANH_VAN_PHONG = "payment/kinh-doanh-van-phong";
export const CREATE_GOAL = "goal/store";
export const UPDATE_GOAL = "goal/update";
export const GET_GOAL = "goal/get-goal";
export const GET_MANAGER_GOAL = "goal/get-manager-goal";
export const GET_LEADER_BOARD_SALE = "leaderboard/sale";
export const EXPORT_TOP_LEADER_BOARD_SALE = "leaderboard/export-sale";
export const GET_LEADER_BOARD_MANAGER = "leaderboard/manager";
export const GET_MANAGER_GOAL_LIST = "goal/get-list-goal";
export const GET_SALE_GOAL_LIST = "goal/get-list-goal-by-sale";
export const RESTORE_GOAL_BY_SALE = "goal/restore-goal-by-sale";
export const GET_ERROR_TARGET_PROGRESS_LIST = "report-error-target-progress-list";
export const GET_ERROR_TARGET_PROGRESS_TOTAL = "get-total-error-target-progress";


//report-rsm
export const REPORT_RSM_DOANH_SO_DOI_NHOM = "report-rsm/doanh-so-doi-nhom";
export const REPORT_RSM_DOANH_THU_THUC_TE = "report-rsm/doanh-thu-thuc-te";
export const REPORT_RSM_BAO_CAO_DOANH_SO = "report-rsm/bao-cao-doanh-so";
export const REPORT_RSM_TANG_TRUONG = "report-rsm/bao-cao-tang-truong";
export const REPORT_LIST_RSM = "report-rsm/list-rsm";


// mutation types
export const KIEU_MAU = 500000000;
export const TIEN_PHONG = 800000000;
export const LY_TUONG = 1000000000;

// state types
const state = {
};

const getters = {

};

const actions = {
    [EXPORT_TOP_LEADER_BOARD_SALE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${EXPORT_TOP_LEADER_BOARD_SALE}`, payload).then(({data}) => {
                let filename = "Bang-xep-hang-sale.xlsx";
                let anchor = document.createElement("a");
                anchor.setAttribute("download", filename);
                anchor.setAttribute("href", data.data);
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [REPORT_HUMANRE_SOURCE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_HUMANRE_SOURCE}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [REPORT_KINH_DOANH_DOI](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_KINH_DOANH_DOI}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_KINH_DOANH_DOI_V2](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_KINH_DOANH_DOI_V2}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_KINH_DOANH_DOI_CHI_TIET](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${REPORT_KINH_DOANH_DOI_CHI_TIET}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_KINH_DOANH_DOI_CHI_TIET_V2](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${REPORT_KINH_DOANH_DOI_CHI_TIET_V2}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_KINH_DOANH_NGAY](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_KINH_DOANH_NGAY}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_KINH_DOANH_KENH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_KINH_DOANH_KENH}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_KINH_DOANH_VAN_PHONG](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_KINH_DOANH_VAN_PHONG}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [CREATE_GOAL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CREATE_GOAL}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    reject(response);
                });
        });
    },

    [UPDATE_GOAL](context, payload) {
        return new Promise((resolve, reject) => {
                ApiService.post(`/${UPDATE_GOAL}/${payload.id}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    reject(response);
                });
        });
    },
    [GET_GOAL](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_GOAL}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [GET_MANAGER_GOAL](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_MANAGER_GOAL}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_MANAGER_GOAL_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_MANAGER_GOAL_LIST}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_SALE_GOAL_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_SALE_GOAL_LIST}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [RESTORE_GOAL_BY_SALE](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${RESTORE_GOAL_BY_SALE}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },


    [GET_LEADER_BOARD_SALE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_LEADER_BOARD_SALE}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_LEADER_BOARD_MANAGER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_LEADER_BOARD_MANAGER}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    // report rsm
    [REPORT_RSM_DOANH_SO_DOI_NHOM](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_RSM_DOANH_SO_DOI_NHOM}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_RSM_DOANH_THU_THUC_TE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_RSM_DOANH_THU_THUC_TE}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_RSM_BAO_CAO_DOANH_SO](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_RSM_BAO_CAO_DOANH_SO}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_RSM_TANG_TRUONG](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_RSM_TANG_TRUONG}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },
    [REPORT_LIST_RSM](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${REPORT_LIST_RSM}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    resolve(response);
                });
        });
    },

    [GET_ERROR_TARGET_PROGRESS_LIST](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_ERROR_TARGET_PROGRESS_LIST, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

     [GET_ERROR_TARGET_PROGRESS_TOTAL](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_ERROR_TARGET_PROGRESS_TOTAL, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
